export default __webpack_public_path__ + "static/media/aboutmeimage.5757633e.jpg";